import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ModalFinalizacaoComponent } from '../view/shared/modal-finalizacao/modal-finalizacao.component';

export interface HasUnsavedChanges {
  hasPendingChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (cmp) => {
  if (!cmp?.hasPendingChanges?.()) return true;

  const dialog = inject(MatDialog);
  const ref = dialog.open(ModalFinalizacaoComponent, {
    width: '600px',
    data: {
      isAviso: true,
      titulo: 'Sair sem salvar',
      conteudo:
        'Ao sair sem salvar, você perderá todo o progresso e as informações preenchidas até o momento. Deseja sair?',
      possuiAcoes: true,
      acao: 'Sair',
    },
  });

  return ref.afterClosed() as Observable<boolean>;
};